import { hooks } from '@/store.js'
import { Button } from '../ui/button.js'
import { ArrowLeftIcon, DotsVerticalIcon } from '@radix-ui/react-icons'
import { format } from 'date-fns'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu.js'
import { Habit } from '@habitus/verdant'

export const EditHeader = ({ habit, onBack }: { habit: Habit; onBack: () => void }) => {
  const client = hooks.useClient()
  const records = hooks.useAllRecords()
  const { id, createdAt } = hooks.useWatch(habit)

  return (
    <div className="flex w-full items-center gap-1">
      <Button variant="ghost" className="-ml-4 gap-2" onClick={onBack}>
        <ArrowLeftIcon />
        Back to list
      </Button>
      <div className="ml-auto text-sm text-gray-500">Started on {format(createdAt, 'PPP')}</div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button size="icon" variant="ghost">
            <DotsVerticalIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuGroup>
            <DropdownMenuItem
              onClick={() => {
                onBack()
                setTimeout(() => {
                  client
                    .batch()
                    .run(() => {
                      client.records.deleteAll(
                        records.filter((r) => r.get('parentId') === id).map((r) => r.get('id')),
                      )
                      client.habits.delete(id)
                    })
                    .commit()
                }, 750)
              }}
            >
              Delete habit
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
